<template>  
<div>  
  <h4>Produtos em Estoque por Unidade</h4> 
    <table class="table table-striped table-bordered">
        <thead>
            <tr>
                <td>Unidade</td>
                <td>Produto</td>
                <td>Quantidade</td>
            </tr>
        </thead>
        <tbody> 
            <tr v-for="row of lista">
                <td>{{ textoUnidade(row.Unidade) }}</td>
                <td class="text-left">{{ row.Produto }}</td>
                <td>{{ row.Quantidade }}</td>
            </tr>
            <tr v-if="lista.length == 0">
                <td colspan="3">Nenhum resultado para exibir</td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="3"> &nbsp; </td>
            </tr>
        </tfoot>
    </table>
</div>
</template>
<script>
export default {
  methods: {
    temporizador: function () {
      setInterval(() => this.listar(), 60000)
    },
    listar: function () {
      this.$http.get('dashboard/estoque-momento')
      .then(function (res) {
        this.lista = res.body
      })
    },
    textoUnidade (id) {
      let escrito = ''
      switch (id) {
        case 0:
          escrito = 'Matriz'
          break
        case 1:
          escrito = 'ABC'
          break
        case 2:
          escrito = 'Alphaville'
          break
        case 4:
          escrito = 'Campinas'
          break
        case 5:
          escrito = 'Curitiba'
          break
        case 6:
          escrito = 'Faria Lima'
          break
        case 7:
          escrito = 'Guarulhos'
          break
        case 8:
          escrito = 'Jundiaí'
          break
        case 10:
          escrito = 'Rio de Janeiro'
          break
        case 11:
          escrito = 'Santo Amaro'
          break
        case 14:
          escrito = 'Recife'
          break
      }
      return escrito
    }
  },
  created: function () {
    this.listar()
    this.temporizador()
  },
  data () {
    return {
      lista: []
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// EstoqueNoMomento.vue?36bd6902